import { db } from '@/api/firebase'

const routesLogRef = db.collection('routes_log')
const routeLogRef = (routeId: string) => routesLogRef.doc(routeId)

export {
  routesLogRef,
  routeLogRef
}